var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordLegalCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.39644 8.58211L0.14644 5.33211C-0.0488135 5.13686 -0.0488135 4.82027 0.14644 4.625L0.85353 3.91789C1.04878 3.72262 1.36539 3.72262 1.56064 3.91789L3.75 6.10723L8.43935 1.41789C8.6346 1.22264 8.95121 1.22264 9.14646 1.41789L9.85355 2.125C10.0488 2.32025 10.0488 2.63684 9.85355 2.83211L4.10355 8.58213C3.90828 8.77738 3.59169 8.77738 3.39644 8.58211Z",
    fill: "#0CD514"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordLegalCheck);
export default __webpack_public_path__ + "static/media/passwordLegalCheck.41989e1dd9155e990cfaaa036ab6e1b7.svg";
export { ForwardRef as ReactComponent };